(function () {
  var STORAGE_KEY = 'traceability:last';
  var UNAVAILABLE =
    'Traceability is temporarily unavailable. Please try again in a moment.';

  function normalizeCode(value) {
    return String(value == null ? '' : value)
      .replace(/\\+/g, '/')
      .trim()
      .toLowerCase();
  }

  function normalizeUpc(value) {
    return String(value == null ? '' : value).replace(/\D/g, '').replace(/^0+/, '');
  }

  function lookupPath(base, upc, lot, brand) {
    var params = new URLSearchParams();
    params.set('upc', upc);
    params.set('lot', lot);
    if (brand) params.set('brand', brand);
    var path = base || '/apps/traceability/lookup';
    return path + (path.indexOf('?') >= 0 ? '&' : '?') + params.toString();
  }

  async function lookup(url, signal) {
    var res = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: signal,
    });
    var text = await res.text();
    var trimmed = (text || '').trim();
    if (!trimmed || trimmed.charAt(0) !== '{') {
      return { ok: false, found: false, errorCode: 'UNAVAILABLE', message: UNAVAILABLE };
    }
    try {
      return JSON.parse(trimmed);
    } catch (err) {
      return { ok: false, found: false, errorCode: 'UNAVAILABLE', message: UNAVAILABLE };
    }
  }

  function formatDate(value) {
    if (!value) return '';
    var parts = String(value).split('-');
    if (parts.length !== 3) return String(value);
    return parts[1] + '/' + parts[2] + '/' + parts[0];
  }

  function dash(value) {
    return value == null || String(value).trim() === '' ? '—' : String(value);
  }

  function setText(id, value) {
    var el = document.getElementById(id);
    if (el) el.textContent = value == null ? '' : String(value);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isSafeHtml(value) {
    return /<(p|div|span|br|strong|em|ul|ol|li)\b/i.test(String(value || ''));
  }

  function richTextToHtml(value) {
    if (value == null || value === '') return '';
    var node = value;
    if (typeof value === 'string') {
      var trimmed = value.trim();
      if (trimmed.charAt(0) !== '{') {
        return isSafeHtml(trimmed) ? trimmed : escapeHtml(trimmed);
      }
      try {
        node = JSON.parse(trimmed);
      } catch (e) {
        return escapeHtml(trimmed);
      }
    }
    function walk(n) {
      if (!n) return '';
      if (typeof n === 'string') return escapeHtml(n);
      if (n.type === 'text') return escapeHtml(n.value || '');
      var kids = (n.children || []).map(walk).join('');
      if (n.type === 'paragraph') return kids ? '<p>' + kids + '</p>' : '';
      return kids;
    }
    return walk(node);
  }

  function toLegacyProduct(data) {
    var lot = data.lot || {};
    var product = data.product || {};
    var variant = data.variant || {};
    var certifications = (data.certifications || []).map(function (item, index) {
      return {
        display_name: item.display_name || item.name || '',
        description: item.description || '',
        image: item.image || item.icon || '',
        display_order: item.display_order == null ? index : item.display_order,
      };
    });

    return {
      id: product.id,
      title: product.title || '',
      handle: product.handle || '',
      image: product.image || lot.product_image || '',
      upc: lot.upc || variant.barcode || '',
      lot: {
        code: lot.code || '',
        upc: lot.upc || '',
        bottling_date: lot.bottling_date || '',
        free_fatty_acid: lot.free_fatty_acid || '',
        oleic_acid: lot.oleic_acid || '',
        total_phenols_mg_kg: lot.total_phenols_mg_kg || '',
        harvest_season: lot.harvest_season || '',
        test_date: lot.test_date || lot.date_of_test_analysis || '',
      },
      certifications: certifications,
    };
  }

  function showDynamic(selector, show) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.hidden = !show;
      el.classList.toggle('is-ready', show);
    });
  }

  function fillPlaceholders(product) {
    if (!product || !product.lot) return;

    setText('productName', product.title);
    setText('harvest_season', dash(product.lot.harvest_season));
    setText('bottling_date', dash(formatDate(product.lot.bottling_date)));
    setText('test_date', dash(formatDate(product.lot.test_date)));
    setText('free_fatty_acid', dash(product.lot.free_fatty_acid));
    setText('total_phenols_mg_kg', dash(product.lot.total_phenols_mg_kg));
    setText('oleic_acid', dash(product.lot.oleic_acid));

    var image = document.getElementById('image');
    if (image && product.image) image.setAttribute('src', product.image);

    showDynamic('[data-traceability-dynamic]', true);

    var certRoot = document.querySelector('[data-traceability-certs]');
    var list = document.getElementById('certifications');
    var certs = (product.certifications || []).slice().sort(function (a, b) {
      return (a.display_order || 0) - (b.display_order || 0);
    });

    if (certRoot) certRoot.hidden = false;
    var usable = certs.filter(function (item) {
      return (item.display_name || item.image || item.description);
    });
    if (!list || usable.length === 0) return;
    list.innerHTML = '';
    certs = usable;
    certs.forEach(function (item) {
      var wrap = document.createElement('div');
      wrap.className = 'grid-view-item d-flex flex-column justify-content-center';
      wrap.style.width = '280px';
      var desc = item.description || '';
      wrap.innerHTML =
        '<div style="margin: 0 auto; width:60px; height:60px;">' +
        (item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.display_name) + '"/>'
          : '') +
        '</div>' +
        '<div class="mt-2 fw-bold">' +
        escapeHtml(item.display_name) +
        '</div>' +
        '<div style="font-size:13px;">' +
        richTextToHtml(desc) +
        '</div>';
      list.appendChild(wrap);
    });
  }

  function persist(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (err) {}
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      return null;
    }
  }

  function cacheMatches(data, upc, lot) {
    if (!data || !data.found || !data.lot) return false;
    var dataLot = normalizeCode(data.lot.code);
    var dataUpc = normalizeUpc(data.lot.upc || (data.variant && data.variant.barcode) || '');
    return dataLot === normalizeCode(lot) && dataUpc === normalizeUpc(upc);
  }

  function applyFound(data) {
    window.traceability = data;
    window.product = toLegacyProduct(data);
    fillPlaceholders(window.product);
    document.dispatchEvent(new CustomEvent('traceability:ready', { detail: data }));
    document.dispatchEvent(new CustomEvent('moresh-traceability-ready'));
  }

  function searchConfig(root) {
    return {
      brand: root.getAttribute('data-brand') || 'oil',
      resultUrl: root.getAttribute('data-result-url') || '/pages/traceability-result',
      lookupUrl: root.getAttribute('data-lookup-url') || '/apps/traceability/lookup',
    };
  }

  function resultConfig() {
    var el = document.getElementById('traceability-result-boot');
    return {
      lookupUrl: (el && el.getAttribute('data-lookup-url')) || '/apps/traceability/lookup',
      brand: (el && el.getAttribute('data-brand')) || 'oil',
      searchUrl: (el && el.getAttribute('data-search-url')) || '/pages/traceability',
    };
  }

  function redirectToSearch(upc, lot, message) {
    if (window.Shopify && Shopify.designMode) return;
    var url = new URL(resultConfig().searchUrl, window.location.origin);
    if (upc) url.searchParams.set('upc', upc);
    if (lot) url.searchParams.set('lot', lot);
    if (message) url.searchParams.set('msg', message);
    window.location.href = url.pathname + url.search;
  }

  function initDialog(root) {
    var dialog = root.querySelector('#traceabilityDialog') || document.getElementById('traceabilityDialog');
    if (!dialog) return null;
    var searchingPane = dialog.querySelector('[data-trace-state="searching"]');
    var errorPane = dialog.querySelector('[data-trace-state="error"]');
    var abort = null;

    function setState(state) {
      searchingPane.hidden = state !== 'searching';
      errorPane.hidden = state !== 'error';
      dialog.setAttribute('aria-busy', state === 'searching' ? 'true' : 'false');
    }

    function open(state) {
      dialog.hidden = false;
      requestAnimationFrame(function () {
        dialog.classList.add('is-open');
      });
      setState(state);
      document.body.classList.add('trace-dialog-open');
    }

    function close() {
      if (abort) {
        abort.abort();
        abort = null;
      }
      dialog.classList.remove('is-open');
      document.body.classList.remove('trace-dialog-open');
      setTimeout(function () {
        dialog.hidden = true;
      }, 280);
    }

    dialog.querySelectorAll('[data-trace-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (dialog.getAttribute('aria-busy') === 'true' && el.classList.contains('trace-dialog__backdrop')) {
          return;
        }
        close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dialog.classList.contains('is-open') && dialog.getAttribute('aria-busy') !== 'true') {
        close();
      }
    });

    return {
      open: open,
      close: close,
      setState: setState,
      setAbort: function (controller) {
        abort = controller;
      },
      clearAbort: function () {
        abort = null;
      },
    };
  }

  function initSearch(root) {
    if (!root || root.getAttribute('data-trace-search-ready') === '1') return;
    var upcInput = root.querySelector('#txtUpc');
    var lotInput = root.querySelector('#txtLot');
    var message = root.querySelector('#message');
    var button = root.querySelector('.btn-search');
    var cfg = searchConfig(root);
    var dialog = initDialog(root);
    if (!upcInput || !lotInput) return;

    var params = new URLSearchParams(window.location.search);
    if (params.get('upc')) upcInput.value = params.get('upc');
    if (params.get('lot')) lotInput.value = params.get('lot');
    if (params.get('msg') && message) message.textContent = params.get('msg');

    async function onSearch(event) {
      if (event) event.preventDefault();
      if (message) message.textContent = '';

      var upc = (upcInput.value || '').trim();
      var lot = (lotInput.value || '').trim();
      if (!upc || !lot) {
        if (message) message.textContent = 'Please provide UPC & Lot';
        return;
      }

      if (button) button.disabled = true;
      if (dialog) dialog.open('searching');

      var controller = new AbortController();
      if (dialog) dialog.setAbort(controller);

      try {
        var data = await lookup(lookupPath(cfg.lookupUrl, upc, lot, cfg.brand), controller.signal);
        if (dialog) dialog.clearAbort();

        if (data && data.ok && data.found) {
          persist(data);
          var destUrl = new URL(cfg.resultUrl, window.location.origin);
          destUrl.searchParams.set('upc', upc);
          destUrl.searchParams.set('lot', lot);
          window.location.href = destUrl.pathname + destUrl.search;
          return;
        }

        if (dialog) dialog.setState('error');
        else if (message) {
          message.textContent =
            (data && data.message) ||
            'Oops, we couldn’t find your product. Please verify your UPC and lot number.';
        }
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        if (dialog) dialog.setState('error');
        else if (message) message.textContent = UNAVAILABLE;
      } finally {
        if (button) button.disabled = false;
      }
    }

    if (button && !button.getAttribute('data-trace-bound')) {
      button.setAttribute('data-trace-bound', '1');
      button.addEventListener('click', onSearch);
    }
    [upcInput, lotInput].forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') onSearch(e);
      });
    });
    window.fnSearch = onSearch;
    root.setAttribute('data-trace-search-ready', '1');
  }

  function bindSearchRoots() {
    document.querySelectorAll('[data-traceability-search], .traceability').forEach(initSearch);
  }

  async function bootResult() {
    var params = new URLSearchParams(window.location.search);
    var upc = (params.get('upc') || '').trim();
    var lot = (params.get('lot') || '').trim();
    var oseid = params.get('oseid');
    var cfg = resultConfig();

    if (oseid) {
      applyFound({
        ok: true,
        found: true,
        product: {
          id: 8316883140894,
          title: 'Moresh Moroccan Extra Virgin Olive Oil',
          image: '//moresh.ca/cdn/shop/products/Moresh500mlEVOO_small.jpg?v=1684230189',
        },
        variant: { barcode: '832650003007' },
        lot: {
          code: 'L0002/2007',
          upc: '832650003007',
          bottling_date: '2022-11-04',
          free_fatty_acid: '0.30',
          oleic_acid: '67',
          total_phenols_mg_kg: '390',
          harvest_season: '2022',
          test_date: '2022-11-01',
        },
        certifications: [],
      });
      return;
    }

    if (!upc || !lot) {
      redirectToSearch('', '', 'Please provide UPC & Lot');
      return;
    }

    var cached = readCache();
    if (cacheMatches(cached, upc, lot)) {
      applyFound(cached);
      return;
    }

    var data = await lookup(lookupPath(cfg.lookupUrl, upc, lot, cfg.brand));
    if (data && data.ok && data.found) {
      persist(data);
      applyFound(data);
      return;
    }

    redirectToSearch(
      upc,
      lot,
      (data && data.message) ||
        'Oops, we couldn’t find your product. Please verify your UPC and lot number.'
    );
  }

  function boot() {
    bindSearchRoots();
    if (document.getElementById('traceability-result-boot')) bootResult();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.traceability .btn-search, [data-traceability-search] .btn-search');
    if (!btn) return;
    var root = btn.closest('[data-traceability-search]') || btn.closest('.traceability');
    if (!root) return;
    if (!root.getAttribute('data-trace-search-ready')) initSearch(root);
    if (typeof window.fnSearch === 'function') {
      e.preventDefault();
      window.fnSearch(e);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', bindSearchRoots);
})();
